import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from '../src/store';
import VueGtm from 'vue-gtm'
import axiosInterceptors from '@/utils/axiosInterceptors';
import extended from '@/utils/extendedFieldValidations';
import '@/utils/globalFilters';
import { createHead } from '@unhead/vue/client';
import { configure } from 'vee-validate';
import { createGtag } from "vue-gtag";
import { VueReCaptcha } from 'vue-recaptcha-v3'; 
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css'; 
import './assets/tooltip.css';

const app = createApp(App); // Create the app instance

app.config.compatConfig = {
  GLOBAL_MOUNT: true,
  GLOBAL_PROTOTYPE: true,
}

const head = createHead();

const gtag = createGtag({
  config: { id: window.config.GA_ID }
})

app.use(gtag)

app.use(VueGtm, {
  id: window.config.GTM_ID,
  debug: true,
  trackOnNextTick: false,
});

app.use(VueReCaptcha, {
  siteKey: window.config.RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: false, 
  },
});

app.use(FloatingVue, {
  themes: {
    'my-custom-tooltip': {
      $extend: 'tooltip', 
    },
  },
});

axiosInterceptors();

configure({
  validateOnBlur: true,
  validateOnChange: true,
  validateOnInput: false,
  validateOnModelUpdate: true,
});

// extended field validation rules for vee-validate
extended.alphaNum();
extended.fieldRequired();
extended.minDate();
extended.minMax();
extended.max();
extended.monthBetween();
extended.specialChars();
extended.validYear();

app.use(head);
app.use(router);
app.use(store);
app.mount('#app');